"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const EventTarget_1 = __importDefault(require("./EventTarget"));
class PhantomTextArea extends EventTarget_1.default {
    _element = document.createElement("textarea");
    _container = document.querySelector(".canvaskit-editor");
    _isCompositionStarted = false;
    _heightInPixel = 24;
    _widthInPixel = 0;
    _initializeAttributes() {
        this._element.style.width = `${this._widthInPixel}px`;
        this._element.style.height = `${this._heightInPixel}px`;
    }
    constructor() {
        super();
        this._element.classList.add("phantom");
        this._element.setAttribute("autocorrect", "off");
        this._element.autocapitalize = "none";
        this._element.autocomplete = "off";
        this._element.spellcheck = false;
        this._element.tabIndex = 0;
        this._element.wrap = "off";
        this._element.setAttribute("role", "textbox");
        this._element.setAttribute("aria-multiline", "true");
        this._element.setAttribute("aria-haspopup", "false");
        this._element.setAttribute("aria-autocomplete", "both");
        this._initializeAttributes();
        this._element.addEventListener("compositionstart", (e) => {
            this._isCompositionStarted = true;
        });
        this._element.addEventListener("compositionend", (e) => {
            if (e.data.length > 0) {
                this.dispatchEvent({ type: "insert", text: e.data });
            }
            this._element.value = "";
            this._isCompositionStarted = false;
        });
        this._element.addEventListener("input", () => {
            if (this._isCompositionStarted) {
                return;
            }
            this.dispatchEvent({ type: "insert", text: this._element.value });
            this._element.value = "";
        });
        this._element.addEventListener("keydown", (e) => {
            switch (e.key) {
                case "Backspace":
                    this.dispatchEvent({ type: "backspace" });
                    break;
                case "Delete":
                    this.dispatchEvent({ type: "delete" });
                    break;
                case "ArrowUp":
                    this.dispatchEvent({ type: "up" });
                    break;
                case "ArrowDown":
                    this.dispatchEvent({ type: "down" });
                    break;
                case "ArrowLeft":
                    this.dispatchEvent({ type: "left" });
                    break;
                case "ArrowRight":
                    this.dispatchEvent({ type: "right" });
                    break;
            }
        });
        this._container?.appendChild(this._element);
    }
    get height() {
        return this._heightInPixel;
    }
    set height(value) {
        this._heightInPixel = value;
        this._element.style.height = `${value}px`;
    }
    move(x, y) {
        this._element.style.top = `${y}px`;
        this._element.style.left = `${x}px`;
    }
    focus() {
        this._element.focus();
    }
    show() {
        this._element.style.display = "block";
    }
    hide() {
        this._element.style.display = "";
    }
}
exports.default = PhantomTextArea;
